import { paymentModeEnum } from "../../../../state/initialState";
import {
  removeGlobalErrorMessageIfMatchesThisString,
  updateGlobalErrorMessage,
} from "../../../../actions/globalError";
import React, { Component } from "react";
import { connect } from "react-redux";
import objectAssign from "object-assign";
import {
  updateCheckoutAppointmentStepData,
  updateGettingStripeToken,
  updateBookingToInvoice,
  changeTipPopupVisibility,
} from "../../../../actions/checkoutAppointmentStep";
import { decimalPoint } from "../../../../utils/helpers";
import { ValidMe } from "../../../shared/validMeReact";
import Txt from "../../../shared/textInput";
import {
  injectStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
} from "react-stripe-elements";
import { updateGlobalSuccessMessage } from "../../../../actions/globalSuccess";

@connect(mapStateToProps)
class CreditCardPaymentForm extends Component {
  constructor(props) {
    super(props);
  }

  dispatchUpdateCheckoutAppointmentStepData = (data) => {
    this.props.dispatch(updateCheckoutAppointmentStepData(data));
  };

  updateCheckoutStep = (data) => {
    let newData = objectAssign(
      {},
      this.props.checkoutAppointmentStepData,
      data
    );
    this.dispatchUpdateCheckoutAppointmentStepData(newData);
  };

  componentDidUpdate = () => {
    let { doCreditCardFormPayment } = this.props.checkoutAppointmentStepData;
    if (doCreditCardFormPayment) {
      this.updateCheckoutStep({ doCreditCardFormPayment: false });
      this.getStripeTokenAndDoPayment();
    }
  };

  handleNameOnCardChange = (ev) => {
    this.updateCheckoutStep({ nameOnCard: ev.target.value });
  };

  handleCardNumberChange = (ev) => {
    if (ev.error) {
      this.updateCheckoutStep({ cardNumberValid: false });
    } else {
      this.updateCheckoutStep({ cardNumberValid: true });
    }
  };

  handleMonthYearOnCardChange = (ev) => {
    if (ev.error) {
      this.updateCheckoutStep({ cardExpValid: false });
    } else {
      this.updateCheckoutStep({ cardExpValid: true });
    }
  };

  handleCvvOnCardChange = (ev) => {
    if (ev.error) {
      this.updateCheckoutStep({ cardCvvValid: false });
    } else {
      this.updateCheckoutStep({ cardCvvValid: true });
    }
  };

  canCheckoutCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canCheckoutAllBookings ||
      limitedPermissions.bookingsCheckoutableByCurrentUser.indexOf(
        currentBookingId
      ) > -1
    );
  };

  changePaymentAmountWithinConstraints = (ev) => {
    let { InvoiceCantBeOverpaid } = window.APP.LANGUAGE.Errors;
    const { outstandingamount } = this.props.invoiceData;
    let paymentAmount = ev.target.value.replace("$", "");

    if (
      (/[0-9]+\.?([0-9]{0,2})?$/.test(paymentAmount) &&
        Number(paymentAmount) <= outstandingamount) ||
      paymentAmount.length == 0
    ) {
      const decimalPlace = paymentAmount.split(".")[1];
      if (decimalPlace && decimalPlace.length > 2) {
        return;
      }
      this.updateCheckoutStep({ paymentAmount: paymentAmount });
      this.props.dispatch(
        removeGlobalErrorMessageIfMatchesThisString(InvoiceCantBeOverpaid)
      );
    }
  };

  handleChangeTipPopupVisibility = (visibility) => {
    this.props.dispatch(changeTipPopupVisibility(visibility));
  };

  formatPaymentField = () => {
    let { paymentAmount } = this.props.checkoutAppointmentStepData;
    this.updateCheckoutStep({ paymentAmount: decimalPoint(paymentAmount) });
  };

  getStripeTokenAndDoPayment = () => {
    //a stripe token matches a credit card on stripe's db
    const { currentBookingId } = this.props;
    const {
      nameOnCard,
      paymentAmount,
    } = this.props.checkoutAppointmentStepData;
    const { UnknownApiError } = window.APP.LANGUAGE.Errors;
    let { PaymentSuccessfulMessage } = window.APP.LANGUAGE.Success;

    this.props.dispatch(removeGlobalErrorMessageIfMatchesThisString(""));
    this.props.dispatch(updateGettingStripeToken(true));

    if (this.props.stripe) {
      let cb = () => {
        this.props.dispatch(
          updateGlobalSuccessMessage({
            message: PaymentSuccessfulMessage,
            icon: "saved_icon",
          })
        );
      };
      const chargeAmount = Number(paymentAmount);

      this.props.stripe.createToken({ name: nameOnCard }).then((result) => {
        this.props.dispatch(updateGettingStripeToken(false));

        if (result.error) {
          console.log(result.error);
          this.props.dispatch(
            updateGlobalErrorMessage({ message: result.error.message })
          );
        } else if (result.token) {
          let stripeToken = result.token.id;
          const payload = {
            token: stripeToken,
            chargeamount: chargeAmount,
          };
          this.props.dispatch(
            updateBookingToInvoice(currentBookingId, payload, cb)
          );
        }
      });
    } else {
      console.log("Form submitted before Stripe.js loaded.");
    }
  };

  storeCardForLaterUse = () => {
    //a stripe token matches a credit card on stripe's db
    const { StoreCardSuccessfully } = window.APP.LANGUAGE.Success;
    const { nameOnCard } = this.props.checkoutAppointmentStepData;
    const { UnknownApiError } = window.APP.LANGUAGE.Errors;

    let that = this;
    let storeCardAgainstBooking = () => {
      const { currentBookingId } = this.props;

      this.props.dispatch(updateGettingStripeToken(true));
      if (this.props.stripe) {
        this.props.stripe.createToken({ name: nameOnCard }).then((result) => {
          this.props.dispatch(updateGettingStripeToken(false));

          if (result.error) {
            console.log(result.error);
            this.props.dispatch(
              updateGlobalErrorMessage({ message: result.error.message })
            );
          } else if (result.token) {
            let stripeToken = result.token.id;
            const payload = { token: stripeToken };
            let cb = () => {
              this.props.dispatch(updateGlobalErrorMessage(""));
              this.props.dispatch(
                updateGlobalSuccessMessage({
                  message: StoreCardSuccessfully,
                  icon: "saved_icon",
                })
              );
              if (this.props.afterSaveHandler) {
                this.props.afterSaveHandler();
              }
            };
            this.props.dispatch(
              updateBookingToInvoice(currentBookingId, payload, cb)
            );
          }
        });
      } else {
        console.log("Form submitted before Stripe.js loaded.");
      }
    };
    if (this.props.beforeSaveHandler) {
      this.props.beforeSaveHandler(storeCardAgainstBooking);
    } else {
      storeCardAgainstBooking();
    }
  };

  getCreditCardPaymentCard = () => {
    const { bookingPaymentsData } = this.props;
    if (bookingPaymentsData && bookingPaymentsData.payments) {
      const offlineCardPayment = bookingPaymentsData.payments.find(
        (payment) => {
          return payment.card.cardpresent === false;
        }
      );
      if (offlineCardPayment) {
        return offlineCardPayment.card;
      }
    }
  };

  getCardPaymentForm = () => {
    const { paymentMode, invoiceData, posSettings } = this.props;
    const {
      nameOnCard,
      paymentAmount,
    } = this.props.checkoutAppointmentStepData;
    let {
      CreditCardNameRequired,
      PaymentAmountMissing,
    } = window.APP.LANGUAGE.Errors;
    let {
      NameOnCardPlaceholder,
      CardNumberPlaceholder,
      MonthYearPlaceholder,
      CvvPlaceHolder,
      IncludedTipButton,
      PaymentAmountPlaceholder,
      PaymentSubTitle,
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;
    let disabled = !this.canCheckoutCurrentBooking();

    const disablePayment = invoiceData.status == "PAID";

    let cardForm = () => {
      const cardObject = this.getCreditCardPaymentCard();
      if (cardObject) {
        const cardDataLast4 = cardObject.last4;
        const cardDataType = cardObject.type;
        return (
          <div className="card_icon">
            <div className="card_icon_img" />
            <p>
              {cardDataType} x{cardDataLast4}
            </p>
          </div>
        );
      }

      //TODO CONTINUE HERE
      let that = this;
      const elementStyles = {
        base: {
          color: "#333",
          fontSize: "13px",
          fontWeight: 400,
        },
      };
      return (
        <React.Fragment>
          <Txt
            maxLength="50"
            className="card_name"
            disabled={disablePayment}
            type="input"
            fieldclasses="mrnull"
            onChange={this.handleNameOnCardChange}
            placeholder={NameOnCardPlaceholder}
            value={nameOnCard}
          ></Txt>
          <CardNumberElement
            className="stripe stripe--card_name"
            maxLength="23"
            disabled={disablePayment}
            fieldclasses="mrnull"
            onChange={this.handleCardNumberChange}
            placeholder={CardNumberPlaceholder}
            style={elementStyles}
          />
          <CardExpiryElement
            className="stripe stripe--card_expiry"
            maxLength="5"
            disabled={disablePayment}
            fieldclasses="mrnull"
            onChange={this.handleMonthYearOnCardChange}
            placeholder={MonthYearPlaceholder}
            style={elementStyles}
          />
          <CardCVCElement
            className="stripe stripe--card_ccv"
            maxLength="4"
            disabled={disablePayment}
            fieldclasses="mrnull"
            type="CardCvcElement"
            onChange={this.handleCvvOnCardChange}
            placeholder={CvvPlaceHolder}
            style={elementStyles}
          />
        </React.Fragment>
      );
    };

    let tipLink = (
      <a
        className="tip_link"
        onClick={this.handleChangeTipPopupVisibility.bind(this, true)}
      >
        {IncludedTipButton}
      </a>
    );
    if (disabled || disablePayment) {
      tipLink = <a className="tip_link disabled">{IncludedTipButton}</a>;
    }
    return (
      <div className="ui form credit_card_form">
        {cardForm()}

        {this.props.modalMode ? (
          ""
        ) : (
          <div>
            <div className="tipLabel">
              <label className="tipLabel_title">{PaymentSubTitle}</label>
              &nbsp;
              {posSettings &&
              posSettings.tipssettings &&
              posSettings.tipssettings.enabled
                ? tipLink
                : ""}
            </div>
            <div className="totalLabel">
              <ValidMe
                validmemessage={PaymentAmountMissing}
                fieldclasses="mrnull"
                validmefor="required"
                group="thirdStepCheckoutAppointment"
              >
                <Txt
                  type="input"
                  onBlur={this.formatPaymentField}
                  fieldclasses="mrnull"
                  className="payment_amount active"
                  disabled={disablePayment}
                  onChange={this.changePaymentAmountWithinConstraints}
                  placeholder={PaymentAmountPlaceholder}
                  value={paymentAmount > 0 ? "$" + paymentAmount : ""}
                ></Txt>
              </ValidMe>
            </div>
          </div>
        )}
      </div>
    );
  };

  canCheckoutCurrentBooking = () => {
    let { limitedPermissions, currentBookingId } = this.props;
    return (
      limitedPermissions.canCheckoutAllBookings ||
      limitedPermissions.bookingsCheckoutableByCurrentUser.indexOf(
        currentBookingId
      ) > -1
    );
  };

  getStoreCard = () => {
    const { paymentMode } = this.props;
    const {
      nameOnCard,
      cardNumberValid,
      cardExpValid,
      cardCvvValid,
    } = this.props.checkoutAppointmentStepData;
    let {
      StoreCardForLaterTitle,
      SaveCardButton,
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;

    if (paymentMode != paymentModeEnum.CARD_MODE) return "";

    let disabled = !this.canCheckoutCurrentBooking();

    const cardObject = this.getCreditCardPaymentCard();

    let completelyDisabled =
      disabled ||
      !nameOnCard ||
      !cardNumberValid ||
      !cardExpValid ||
      !cardCvvValid;

    if (cardObject) {
      return <div />;
    } else {
      if (this.props.modalMode) {
        if (completelyDisabled) {
          return (
            <div className="ui button disabled save-card">{SaveCardButton}</div>
          );
        } else {
          return (
            <div
              className="ui button save-card"
              onClick={this.storeCardForLaterUse}
            >
              {SaveCardButton}
            </div>
          );
        }
      } else if (completelyDisabled) {
        return (
          <div className="credit_card_store _disabled">
            {StoreCardForLaterTitle}
          </div>
        );
      } else {
        return (
          <div
            className="credit_card_store _active"
            onClick={this.storeCardForLaterUse}
          >
            {StoreCardForLaterTitle}
          </div>
        );
      }
    }
  };

  render() {
    return (
      <div className={`${this.props.modalMode ? "payment_box" : ""}`}>
        {this.getCardPaymentForm()}
        <div>{this.getStoreCard()}</div>
      </div>
    );
  }
}

export default injectStripe(CreditCardPaymentForm);

function mapStateToProps(state) {
  return {
    currentBookingId: state.bookingReducer.currentBookingId,
    paymentMode: state.appointmentCheckoutReducer.paymentMode,
    checkoutMode: state.appointmentCheckoutReducer.checkoutMode,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    posSettings: state.appointmentCheckoutReducer.posSettings,
    invoiceData: state.appointmentCheckoutReducer.invoiceData,
    appointmentStepData: state.appointmentStepReducer.appointmentStepData,
    bookingPaymentsData: state.appointmentCheckoutReducer.bookingPaymentsData,
    checkoutAppointmentStepData:
      state.appointmentCheckoutReducer.checkoutAppointmentStepData,
    checkoutPreviousMenu: state.menuReducer.checkoutPreviousMenu,
  };
}
